import React from 'react'
import PropTypes from 'prop-types'
import SnInput from '../../front/components/shared/sn-input'
import ImageUpload from '../../components/image/image-upload'
import Button from '../../front/components/shared/sn-button'
import { useTranslation } from 'react-i18next'

/**
 * Sport form component
 * @param {Object} formData
 * @param {string} formData.original_name
 * @param {Number} [formData.id] - if is newly created, id is not accessible
 * @param {string} [formData.imageToSave] - base64 of image, which will be saved. If image is not presented, return null or is not accessible
 * @param {string} [formData.image_path] - image path from API
 * @param {Function} setFormData
 * @param {Function} saveSportForm
 * @return {JSX.Element}
 * @constructor
 */
const SportForm = ({
    formData,
    setFormData,
    saveSportForm,
}) => {
    const { t } = useTranslation()

    return (
        <div className="p-2">
            <div className="form-group">
                <label>Název v databázi</label>
                <SnInput
                    type="text"
                    value={formData?.original_name || ''}
                    className="form-control"
                    onChange={event => setFormData('original_name', event.target.value)}
                />
            </div>
            <div className="form-group">
                <label>
                    <a
                        href={`https://app.lokalise.com/project/686258175d11d738e2d534.80560961/?view=single&reference_lang_id=765&single_lang_id=765&search=sport_${formData?.id}`}
                        target="_blank"
                        rel="noopener"
                    >
                        Název v lokalise
                    </a>
                </label>
                <SnInput
                    type="text"
                    value={t(`sport_${formData?.id}`)}
                    className="form-control"
                    disabled
                />
            </div>
            <div className="form-group">
                <label>
                    Obrázek sportu
                </label>
                <ImageUpload
                    attribute="sport-image"
                    defaultFile={formData?.imageToSave || formData?.image_path || '/images/default-sport.png'}
                    onImageUpdate={(attribute, image) => setFormData('imageToSave', image)}
                    previewWidth="90px"
                    previewHeight="90px"
                    rounded
                    modalDescription={t('mainPicture')}
                    cropShape="round"
                />
            </div>
            <div className="form-group">
                <Button
                    onClick={saveSportForm}
                    className="btn btn-primary btn-block"
                >
                    {t('save')}
                </Button>
            </div>
        </div>
    )
}

SportForm.propTypes = {
    formData: PropTypes.object.isRequired,
    setFormData: PropTypes.func.isRequired,
    saveSportForm: PropTypes.func.isRequired,
}

export default SportForm
